<template>
  <div class="pc_manage">
    <div class="manageTop"></div>
    <div class="title">河南大学教学管理规范化服务管理后台</div>
    <div class="navbar">
      <div
        class="navbaritem"
        @click="choose(1)"
        v-bind:class="{ navbaritem1: whichContent == 1 }"
      >
        分类管理
      </div>
      <div
        class="navbaritem navbaritem2"
        @click="choose(2)"
        v-bind:class="{ navbaritem1: whichContent == 2 }"
      >
        对象管理
      </div>
      <div
        class="navbaritem"
        @click="choose(3)"
        v-bind:class="{ navbaritem1: whichContent == 3 }"
      >
        事项管理
      </div>
      <!-- <div class="navbaritem navbaritem4" @click="choose(4)">发布文章</div> -->
    </div>
    <!-- 分类管理 -->
    <div class="showbararticle1 showbar" v-show="showitem == 1">
      <!-- <div class="header">这里是导航</div> -->
      <!-- 侧边栏 -->
      <div class="sidebar">
        <div
          class="menuitem"
          v-for="(item, index) in titleNav"
          @click="chooseContent(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 右侧内容 -->
      <div class="main classIfyMian">
        <div class="main1">
          <!-- ---------------------------------------------------显示一级分类维护内容 -->
          <div class="firstContent" v-show="showFirstClassify">
            <div class="maintopA">一级分类维护</div>
            <div class="topObj tableClssify0">
              <div class="hidden" @click="showAdd(1)">增加</div>
            </div>
            <div class="table tableClssify dingweiF">
              <!-- 表格标题 -->
              <div class="tableTitle">
                <div class="listName tableListCP tableClssify1 tableClssifyTo5">
                  一级分类代码
                </div>
                <div class="listType tableListCP tableClssify1 tableClssifyTo5">
                  一级分类名称
                </div>
                <div
                  class="listObject tableListCP tableClssify1 tableClssifyTo5"
                >
                  对象
                </div>
                <div
                  class="listObject tableListCP tableClssify1 tableClssifyTo5"
                >
                  主管部门
                </div>
                <div
                  class="listObject tableListCP tableClssify1 tableClssifyTo5"
                >
                  操作
                </div>
              </div>
              <!-- 表格内容 -->
              <div class="tableRow" v-for="(item, index) in firstClassify">
                <div class="tableListCP tableClssify2">
                  {{ item.ClassID }}
                </div>
                <div class="tableListCP tableClssify2 textLeft">
                  {{ item.ClassName }}
                </div>
                <div class="tableListCP tableClssify2">
                  {{ item.ObjectName }}
                </div>
                <div class="tableListCP tableClssify2 textLeft">
                  {{ item.DepartName }}
                </div>
                <div class="tableListCP tableClssify2">
                  <div class="operate">
                    <div
                      class="operateCP"
                      @click="
                        editClicked(
                          'menu1',
                          item.ClassID,
                          item.ClassName,
                          item.Department,
                          item.ClassObjectID
                        )
                      "
                    >
                      编辑
                    </div>
                    <div
                      class="operateCP"
                      @click="deleteClicked('menu1', item.ClassID)"
                    >
                      删除
                    </div>
                  </div>
                </div>
              </div>
              <!-- 一级标题点击新增出来的一行 -->
              <div class="tableRow" v-show="showAdd1">
                <div class="tableListCP tableClssify2"></div>
                <div class="tableListCP tableClssify2">
                  <input
                    type="text"
                    v-model="addClassName"
                    placeholder="请输入一级分类名称"
                    class="inputStyle1"
                  />
                </div>
                <div class="tableListCP tableClssify2">
                  <select
                    class="dropdownStyle1"
                    v-model="itemObj1"
                    @change="ahaha123($event)"
                  >
                    <option :value="item.objectID" v-for="item in itemObjList">
                      {{ item.objectName }}
                    </option>
                  </select>
                </div>
                <div class="tableListCP tableClssify2">
                  <!-- <select
                    class="dropdownStyle1"
                    v-model="itemDepart1"
                    @change="ahaha123($event)"
                  >
                    <option
                      :value="item.departmentID"
                      v-for="item in itemDepart1List"
                    >
                      {{ item.departName }}
                    </option>
                  </select> -->
                </div>
                <div class="tableListCP tableClssify2">
                  <div class="operate">
                    <div class="operateCP" @click="assertClicked('menu1')">
                      确定
                    </div>
                    <div class="operateCP" @click="hidden(1)">取消</div>
                  </div>
                </div>
              </div>
              <!-- 弹窗 -->
              <div class="popup tableClssify3 dingweiS" v-show="showTipMenu1">
                <div class="PopupBox">
                  <div class="PopupBoxTop">
                    <div class="popupBoxTxt">
                      <div class="popupBoxTxtCP popupBoxTxtCPL tableClssify4">
                        一级分类代码:
                      </div>
                      <div class="popupBoxTxtCP popupBoxTxtCPR">
                        {{ id2tip }}
                      </div>
                    </div>
                    <div class="popupBoxTxt">
                      <div class="popupBoxTxtCP popupBoxTxtCPL tableClssify4">
                        一级分类名称:
                      </div>
                      <div class="popupBoxTxtCP popupBoxTxtCPR tableClssify4">
                        <input
                          type="text"
                          class="popupBoxInput"
                          v-model="className2tip"
                        />
                      </div>
                    </div>
                    <!-- <div class="popupBoxTxt">
                      <div class="popupBoxTxtCP popupBoxTxtCPL tableClssify4">
                        主管部门:
                      </div>
                      <select
                        class="dropdownStyle1 dropdownStyle3"
                        v-model="itemDepart1"
                        @change="ahaha123($event)"
                      >
                        <option
                          :value="item.departmentID"
                          v-for="item in itemDepart1List"
                        >
                          {{ item.departName }}
                        </option>
                      </select>
                    </div> -->
                    <div class="popupBoxTxt">
                      <div class="popupBoxTxtCP popupBoxTxtCPL tableClssify4">
                        面向对象:
                      </div>
                      <select
                        class="dropdownStyle1 dropdownStyle3"
                        v-model="itemObj1"
                      >
                        <option
                          :value="item.objectID"
                          v-for="item in itemObjList"
                        >
                          {{ item.objectName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="PopupBoxCfrm">
                    <div class="popupoption" @click="tipOK('menu1')">确定</div>
                    <div class="popupoption" @click="cancleClicked('menu1')">
                      取消
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ---------------------------------------------------显示二级分类维护内容 -->
          <div class="second" v-show="showSecondClassify">
            <div class="maintopA">二级分类维护</div>
            <div class="topObj tableClssify0">
              <div class="classTitle">请选择一级分类</div>
              <div class="classSearch dropdownStyle1">
                <!-- 二级分类中选择一级分类的下拉菜单 -->
                <select v-model="dropdownValue" class="dropdownStyle1">
                  <option :value="item.ClassID" v-for="item in dropdown1">
                    {{ item.ClassName }}
                  </option>
                </select>
              </div>
              <div class="hidden" @click="showAdd(2)" v-show="showAddBtn">
                增加
              </div>
            </div>
            <div class="table tableClssify dingweiF">
              <!-- 表格标题 -->
              <div class="tableTitle">
                <div class="listName tableListCP tableClssify11">
                  二级分类代码
                </div>
                <div class="listType tableListCP tableClssify11">
                  二级分类名称
                </div>
                <div class="listObject tableListCP tableClssify11">操作</div>
              </div>
              <!-- 表格内容 -->
              <div class="tableRow" v-for="(item, index) in secondClassify">
                <div class="tableListCP tableClssify22">
                  {{ item.subClassID }}
                </div>
                <div class="tableListCP tableClssify22">
                  {{ item.subClassName }}
                </div>
                <div class="tableListCP tableClssify22">
                  <div class="operate">
                    <div
                      class="operateCP"
                      @click="
                        editClicked('menu2', item.subClassID, item.subClassName)
                      "
                    >
                      编辑
                    </div>
                    <div
                      class="operateCP"
                      @click.stop="deleteClicked('menu2', item.subClassID)"
                    >
                      删除
                    </div>
                  </div>
                </div>
              </div>
              <!-- 点击二级标题新增出来的一行 -->
              <div class="tableRow" v-show="showAdd2">
                <div class="tableListCP tableClssify22"></div>
                <div class="tableListCP tableClssify22">
                  <input
                    type="text"
                    v-model="addSubClassName"
                    placeholder="请输入二级分类名称"
                    class="inputStyle1"
                  />
                </div>
                <div class="tableListCP tableClssify22">
                  <div class="operate">
                    <div class="operateCP" @click="assertClicked('menu2')">
                      确定
                    </div>
                    <div class="operateCP" @click="hidden(2)">取消</div>
                  </div>
                </div>
              </div>
              <!-- 弹窗 -->
              <div class="popup tableClssify3 dingweiS" v-show="showTipMenu2">
                <div class="PopupBox">
                  <div class="PopupBoxTop">
                    <div class="popupBoxTxt">
                      <div class="popupBoxTxtCP popupBoxTxtCPL tableClssify4">
                        二级分类代码:
                      </div>
                      <div class="popupBoxTxtCP popupBoxTxtCPR">
                        {{ subId2tip }}
                      </div>
                    </div>
                    <div class="popupBoxTxt">
                      <div class="popupBoxTxtCP popupBoxTxtCPL tableClssify4">
                        二级分类名称:
                      </div>
                      <div class="popupBoxTxtCP popupBoxTxtCPR tableClssify4">
                        <input
                          type="text"
                          class="popupBoxInput"
                          v-model="subClassName2tip"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="PopupBoxCfrm">
                    <div class="popupoption" @click="tipOK('menu2')">确定</div>
                    <div class="popupoption" @click="cancleClicked('menu2')">
                      取消
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对象管理 -->
    <div class="showObj" v-show="showitem == 2">
      <div class="obgManage">
        <div class="topObj">
          <div class="hidden" @click="showAdd(3)">增加</div>
        </div>
        <div class="table dingweiF">
          <!-- 表格标题 -->
          <div class="tableTitle">
            <div class="listName tableListCP">对象代码</div>
            <div class="listType tableListCP">对象名称</div>
            <div class="listObject tableListCP">操作</div>
          </div>
          <!-- 表格内容 -->
          <div class="tableRow" v-for="(item, index) in allObj">
            <div class="tableListCP">{{ item.objectID }}</div>
            <div class="tableListCP">{{ item.objectName }}</div>
            <div class="tableListCP">
              <div class="operate">
                <div
                  class="operateCP"
                  @click="editClicked('obj', item.objectID, item.objectName)"
                >
                  编辑
                </div>
                <div
                  class="operateCP"
                  @click="deleteClicked('obj', item.objectID)"
                >
                  删除
                </div>
              </div>
            </div>
          </div>
          <!-- 点击增加后新增的那一行 -->
          <div class="tableRow" v-show="showAdd3">
            <div class="tableListCP"></div>
            <div class="tableListCP">
              <input
                type="text"
                v-model="newObjName"
                placeholder="在此输入对象名称"
                class="inputStyle1"
              />
            </div>
            <div class="tableListCP">
              <div class="operate">
                <div class="operateCP" @click="assertClicked('obj')">确定</div>
                <div class="operateCP" @click="hidden(3)">取消</div>
              </div>
            </div>
          </div>
          <!-- 弹窗 -->
          <div class="popup dingweiS" v-show="showTipObj">
            <div class="PopupBox">
              <div class="PopupBoxTop">
                <div class="popupBoxTxt">
                  <div class="popupBoxTxtCP popupBoxTxtCPL">对象代码:</div>
                  <div class="popupBoxTxtCP popupBoxTxtCPR">
                    {{ objId2tip }}
                  </div>
                </div>
                <div class="popupBoxTxt">
                  <div class="popupBoxTxtCP popupBoxTxtCPL">对象名称:</div>
                  <div class="popupBoxTxtCP popupBoxTxtCPR">
                    <input
                      type="text"
                      class="popupBoxInput"
                      v-model="objName2tip"
                    />
                  </div>
                </div>
              </div>
              <div class="PopupBoxCfrm">
                <div class="popupoption" @click="tipOK('obj')">确定</div>
                <div class="popupoption" @click="cancleClicked('obj')">
                  取消
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 事项管理 -->
    <div class="showbararticle1 showbar" v-show="showitem == 3">
      <!-- <div class="header">这里是导航</div> -->
      <!-- 左侧树 -->
      <div class="sidebar">
        <div
          class="menuitem1"
          v-for="item in allClass1"
          @click="showSubMenu(item.ClassID)"
        >
          {{ item.ClassName }}
          <div
            class="submenuitem"
            v-for="(subItem, index) in tempSubMenu"
            v-show="subItem.classID == item.ClassID"
            @click.stop="subMenuClicked(subItem.subClassID, index)"
            :class="index == dynamicClass ? 'dynamicClass1' : ''"
          >
            {{ subItem.subClassName }}
          </div>
        </div>
      </div>
      <!-- 右侧表格大盒子 -->
      <div class="main">
        <div class="main1 positionF">
          <!-- 添加搜索 -->
          <div class="topsearch">
            <div class="hidden" @click="showAdd(4)">增加</div>
          </div>
          <!-- 表格标题 -->
          <div class="toptitle">
            <div class="listName listCP">事项名称</div>
            <div class="listType listCP">事项类型</div>
            <div class="listObject listCP">面向对象</div>
            <div class="listOperate listCP">操作</div>
          </div>
          <!-- 遍历循环出的内容行 -->
          <div class="contentList" v-for="item in objList" v-show="mainflag">
            <div class="contentCP listCP textLeft">
              {{ item.BusinessName }}
            </div>
            <div class="contentCP listCP textLeft">
              {{ item.ClassName }}-{{ item.SubClassName }}
            </div>
            <div class="contentCP listCP">{{ item.ObjectName }}</div>
            <div class="contentCP listCP">
              <div class="ctnCP" @click="changepage(item)">编辑</div>
              <div
                class="deleteCTN ctnCP"
                @click="deleteClicked('edit', item.BusinessID)"
              >
                删除
              </div>
            </div>
          </div>
          <!-- 页面 -->
          <div class="pageCTN positionS">
            <div class="page">
              <el-pagination
                layout="prev, pager, next"
                :total="totalItem"
                :page-size="10"
                :pager-count="5"
                :hide-on-single-page="true"
                @current-change="currentPage"
                class="elpage"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 发布文章 -->
    <div class="showbararticle2" v-show="showitem == 4">
      <div class="QheadClassify">
        <div class="articleTop">一级分类</div>
        <div class="articleTop">
          <select v-model="itemClassify1" class="dropdownStyle2">
            <option :value="item.ClassID" v-for="item in itemClassify1List">
              {{ item.ClassName }}
            </option>
          </select>
        </div>
        <div class="articleTop">二级分类</div>
        <div class="articleTop">
          <select v-model="itemClassify2" class="dropdownStyle2">
            <option :value="item.subClassID" v-for="item in itemClassify2List">
              {{ item.subClassName }}
            </option>
          </select>
        </div>
        <!-- <div class="articleTop">面向对象</div>
        <div class="articleTop">
          <select v-model="itemOOP" class="dropdownStyle2">
            <option :value="item.objectID" v-for="item in oopList">
              {{ item.objectName }}
            </option>
          </select>
        </div> -->
      </div>
      <div class="QheadName">
        <div class="articleMid">事项名称</div>
        <div class="articleMid">
          <input type="text" v-model="itemName" class="inputStyle3" />
        </div>
      </div>
      <!-- <div class="quillTitle">{{ itemName }}</div> -->
      <quill-editor
        class="quillbox"
        v-model="itemContent"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @ready="onEditorReady($event)"
      >
      </quill-editor>
      <div class="zhanwi12"></div>
      <!-- 电话和主管部门 -->
      <!-- <div class="phoneAndDepart">
        <div class="phoneAndDepartCP">
          <div class="phoneAndDepartCPL">电话：</div>
          <div class="phoneAndDepartCPL phoneAndDepartCPR">
            <input type="text" class="inputstyle2" v-model="itemPhone" />
          </div>
        </div>
        <div class="phoneAndDepartCP">
          <div class="phoneAndDepartCPL">主管部们：</div>
          <div class="phoneAndDepartCPL phoneAndDepartCPR">
            <input type="text" class="inputstyle2" v-model="itemDepart" />
          </div>
        </div>
      </div> -->

      <!-- <div v-show="showUpload1"> -->
      <!-- 添加附件和已有文件 -->
      <div>
        <div class="uploadTitle">添加附件</div>
        <div class="uploadBOX">
          <!-- 右侧上传 -->
          <div class="uploadBoxCP">
            <!-- <div class="historyFileBox">
              <div class="historyFileItem">
                <div class="historyFileType historyFileBg">附加类型</div>
                <div class="historyFileCTN historyFileBg">附件名称</div>
                <div class="historyFileDelete historyFileBg">操作</div>
              </div>
              <div class="historyFileItem" v-for="item in detailFileMSG">
                <div class="historyFileType">
                  {{ item.AttachmentType | toCN }}
                </div>
                <div class="historyFileCTN">{{ item.AttachmentName }}</div>
                <div
                  class="historyFileDelete historyFileDelete1"
                  @click="deleteFile(item.AttachmentID)"
                >
                  删除
                </div>
              </div>
            </div> -->
            <div class="chooseTypeBox">相关表格</div>
            <div class="theUpload">
              <el-upload
                class="upload-demo"
                ref="Theupload1"
                action="https://jwgf.henu.edu.cn:443/attachment/upload"
                :multiple="true"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :file-list="fileList1"
                :auto-upload="false"
                :on-success="upsuccess"
                :before-upload="fileAction1"
                :data="upData"
                :before-remove="beforeRemove"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
                <!-- <el-button
                  style="margin-left: 10px"
                  size="small"
                  type="success"
                  @click="submitUpload"
                  >上传到服务器</el-button
                > -->
                <!-- <div slot="tip" class="el-upload__tip">
              只能上传XXXXX文件，且不超过xxxx
            </div> -->
              </el-upload>
            </div>
          </div>
          <!-- 左侧上传 -->
          <div class="uploadBoxCP">
            <div class="chooseTypeBox">
              制度文件
              <!-- <div class="chooseTypeBoxL">选择上传文件的类型：</div>
              <div class="chooseTypeBoxR">
                <select class="chooseTypeSelect" v-model="AttachmentType">
                  <option value="0">附件</option>
                  <option value="1">表格</option>
                </select>
              </div> -->
            </div>
            <div class="theUpload">
              <el-upload
                class="upload-demo"
                ref="upload"
                action="https://jwgf.henu.edu.cn:443/attachment/upload"
                :multiple="true"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :file-list="fileList"
                :auto-upload="false"
                :on-success="upsuccess"
                :before-upload="fileAction1"
                :data="upData"
                :before-remove="beforeRemove"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
                <!-- <el-button
                  style="margin-left: 10px"
                  size="small"
                  type="success"
                  @click="submitUpload"
                  >上传到服务器</el-button
                > -->
                <!-- <div slot="tip" class="el-upload__tip">
              只能上传XXXXX文件，且不超过xxxx
            </div> -->
              </el-upload>
            </div>
          </div>
        </div>
        <!-- 已有文件 -->
        <div v-show="!fromAdd">
          <div class="uploadTitle">已有文件</div>
          <div class="showAttach">
            <div class="historyFileBox">
              <div class="historyFileItem">
                <div class="historyFileType historyFileBg">附加类型</div>
                <div class="historyFileCTN historyFileBg">附件名称</div>
                <div class="historyFileDelete historyFileBg">操作</div>
              </div>
              <div class="historyFileItem" v-for="item in detailFileMSG">
                <div class="historyFileType">
                  {{ item.AttachmentType | toCN }}
                </div>
                <div class="historyFileCTN">{{ item.AttachmentName }}</div>
                <div
                  class="historyFileDelete historyFileDelete1"
                  @click="deleteFile(item.AttachmentID)"
                >
                  删除
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 取消确定按钮 -->
      <div class="footer">
        <div class="footerL" @click="cancleClicked('edit')">取消</div>
        <div class="footerR" @click="confirm()">确定</div>
      </div>
    </div>
    <div class="bottom">版权所有 © 2021 河南大学教务处</div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import axios from "axios";
export default {
  name: "pc_manage",
  //   name: "demo1",
  filters: {
    toCN: function (num) {
      if (num == 0) {
        return "附件";
      } else if (num == 1) {
        return "表格";
      }
    },
  },
  components: {
    quillEditor,
  },
  watch: {
    // objList: function (val, oldval) {
    //   console.log(val, oldval);
    // },
    dropdownValue: function (val, oldval) {
      console.log(val, oldval);
      this.recordStep1 = val;
      //二级分类维护里 如果选择了一级分类的话 就也显示增加
      if (val) {
        this.showAddBtn = true;
      }

      if (val == 0) {
        console.log("不查询二级分类维护列表");
      } else {
        axios({
          methods: "get",
          url: "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClass/" + val,
        }).then((res) => {
          console.log(res.data);
          this.secondClassify = res.data;
        });
      }
    },
    midTransfer: function (val, oldval) {
      console.log(val);
      this.itemClassify1 = val.classID;
      this.itemDepart = val.department;
    },
    itemClassify1: function (val, oldval) {
      console.log(val);
      if (val == -1) {
        console.log("itemClassify1为-1");
      } else {
        axios({
          methods: "get",
          url: "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClass/" + val,
        }).then((res) => {
          console.log(res.data);
          this.itemClassify2List = res.data;
        });
        console.log(this.itemClassify1List);
        for (let i = 0; i < this.itemClassify1List.length; i++) {
          if (this.itemClassify1List[i].classID == val) {
            console.log(this.itemClassify1List[i].department);
            this.itemDepart = this.itemClassify1List[i].department;
          }
        }
      }
    },
    showitem: function (val, oldval) {
      if (this.showitem == val && this.fromAdd) {
        console.log("触发清空");
        this.itemClassify1 = -1;
        this.itemOOP = -1;
      }
    },
  },
  mounted: function () {
    console.log(document.cookie);
    if (document.cookie == false || document.cookie == "") {
     this.$router.push("./login");
    }

    //开始---------------------------------------------------------------------=============================================
    if (document.cookie == "") {
      this.$router.push("./login");
    } else if (JSON.parse(document.cookie).iflogin == true) {
      console.log("登陆成功");
      this.role = JSON.parse(document.cookie).Department;
      console.log("角色所属部门", this.role);
    } else {
      this.$router.push("./login");
    }
    //结束---------------------------------------------------------------------=============================================

    this.whichContent = 1;
    //根据部门查询所有的一级分类
    this.goInterface("menu1");
  },
  data() {
    return {
      //二级分类维护里 如果选择了一级分类的话 就也显示增加 若为true 则显示增加按钮
      showAddBtn: false,
      //登陆的角色所属部门代码
      role: -1,
      //动态增加属性
      dynamicClass: -1,
      //新增与编辑的区别 是否显示已有文件
      // showFile:false,
      //上传文件携带的两个参数
      upData: {
        BusinessID: 1,
        AttachmentType: 1,
      },
      mainflag: true,
      //显示得是那一部分内容
      whichContent: 0,
      //增加的时候隐藏上传文件
      showUpload1: false,
      //编辑页用来保存文章id以刷新附件列表
      editBusinessID: -1,
      //上传的文件类型
      AttachmentType: 0,
      //查询到的文件列表
      detailFileMSG: [],
      //分页相关
      pageNum: 1,
      totalItem: 1,
      //文件上传时携带的参数
      filedata: "",
      // content: "请在此编辑您需要发布的内容",
      editorOption: {},
      showitem: 1,
      showContent: -1,
      showFirstClassify: true,
      showSecondClassify: false,
      showTipMenu1: false,
      showTipMenu2: false,
      showTipObj: false,
      //文件上传信息
      fileList: [
        // {
        //   name: "1",
        //   url: "1",
        // },
      ],
      fileList1: [
        // {
        //   name: "1",
        //   url: "1",
        // },
      ],
      //是否显示各表格新加的那一行
      showAdd1: false,
      showAdd2: false,
      showAdd3: false,
      showAdd4: false,
      showAdd5: false,
      //中转
      midTransfer: {},
      //二级分类维护记录步骤
      recordStep1: -1,
      //判断从那里进来 true是新增 false是编辑
      fromAdd: false,
      //大编辑页 true新增 false更新
      addOrUpdata: true,
      //上传框
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      //点击一级标题编辑后弹出框中的三个值
      id2tip: -1,
      department2tip: -1,
      className2tip: -1,
      //点击二级标题编辑后弹出框中的两个值
      subId2tip: -1,
      subClassName2tip: -1,
      //点击对象管理编辑后弹出框中的两个值
      objId2tip: -1,
      objName2tip: -1,
      //添加一级标题要填的数据
      // classID: "",
      addClassName: "",
      addDepartment: "",
      //添加二级标题要填的数据
      //dropdownValue
      addSubClassName: "",
      //添加对象所需的数据
      newObjName: "",
      //事项管理详细页用到的所有变量
      itemClassify1: "ClassName", //一级标题的id
      itemClassify2: "SubClassName", //二级标题的id
      itemID: "BusinessID",
      itemOOP: "ObjectName",
      itemName: "BusinessName",
      itemContent: "BusinessContent",
      itemPhone: "ContactPhone",
      itemDepart: "DepartName",
      itemClassify1List: [],
      itemClassify2List: [],
      //首页下拉列表两个值
      itemDepart1: 0,
      itemDepart1List: [],
      //一级分类维护对象的下拉列表中的值
      itemObj1: -1,
      itemObjList: [
        // {objectID:"10",objectName:"学生"}
      ],
      oopList: [
        // { id: 1, name: "分类一" },
        // { id: 2, name: "分类五" },
        // { id: 3, name: "分类三" },
      ], // 面向对象下拉列表
      //查询到的所有对象
      allObj: [
        // {
        //   objectID: "10",
        //   objectName: "学生",
        // },
      ],
      //修改二级标题中下拉列表
      dropdown1: [
        // { classID: 1, className: "啊哈", department: "行政部门" },
        // { classID: 2, className: "啊哈", department: "行政部门" },
      ],
      //修改二级标题中下拉列表值
      dropdownValue: -1,
      //发布事项页对应的下拉列表
      classify1List: [
        { id: 1, name: "分类一" },
        { id: 2, name: "分类二" },
      ],
      classify2List: [
        { id: 1, name: "分类一" },
        { id: 2, name: "分类二" },
        { id: 3, name: "分类三" },
      ],
      firstClassify: [
        {
          classID: 1,
          className: "学籍管理",
          department: "行政部门",
        },
        {
          classID: 2,
          className: "休学退学",
          department: "行政部门",
        },
        {
          classID: 3,
          className: "补考",
          department: "行政部门",
        },
      ],
      secondClassify: [
        // {
        //   classID: 1,
        //   subClassName: "学籍管理",
        //   subClassID: "行政部门",
        // },
      ],
      titleNav: [
        {
          name: "一级分类维护",
          category: 1,
          submenu: [
            { id: 1, content: "学生" },
            { id: 1, content: "教师" },
            { id: 1, content: "管理人员" },
            { id: 1, content: "毕业校友" },
          ],
        },
        {
          name: "二级分类维护",
          category: 2,
          submenu: [
            { id: 1, content: "学生" },
            { id: 1, content: "教师" },
            { id: 1, content: "管理人员" },
            { id: 1, content: "毕业校友" },
          ],
        },
      ],
      nav: [
        {
          name: "教学运行",
          category: 1,
          submenu: [
            { id: 1, content: "1" },
            { id: 2, content: "2" },
            { id: 3, content: "3" },
            { id: 4, content: "4" },
          ],
        },
        {
          name: "教学运行",
          category: 2,
          submenu: [
            { id: 5, content: "1" },
            { id: 6, content: "2" },
            { id: 7, content: "3" },
            { id: 8, content: "4" },
          ],
        },
        {
          name: "教学运行",
          category: 3,
          submenu: [
            { id: 9, content: "1" },
            { id: 10, content: "2" },
            { id: 11, content: "3" },
            { id: 12, content: "4" },
          ],
        },
        {
          name: "教学运行",
          category: 4,
          submenu: [
            { id: 13, content: "1" },
            { id: 14, content: "2" },
            { id: 15, content: "3" },
            { id: 16, content: "4" },
          ],
        },
        {
          name: "教学运行",
          category: 5,
          submenu: [
            { id: 17, content: "1" },
            { id: 18, content: "2" },
            { id: 19, content: "3" },
            { id: 20, content: "4" },
          ],
        },
      ],
      //查询到的所有一级标题
      allClass1: [
        // {
        //   classID: "1:2",
        //   className: "你好",
        //   department: "1",
        // },
      ],
      //根据一级标题查询到的所有二级标题
      tempSubMenu: [
        {
          // subClassID: "-1",
          // classID: "3",
          // subClassName: "名称",
        },
      ],
      objList: [
        // {
        //   BusinessClass: "1001",
        //   BusinessDepartment: "10",
        //   BusinessID: 1001,
        //   BusinessName: "关于开学军训的通知",
        //   BusinessObject: "10",
        //   ClassID: "10",
        //   ClassName: "开学教育21",
        //   Department: "15",
        //   ObjectName: "学生1",
        //   SubClassName: "军训",
        // },
      ],
    };
  },
  methods: {
    change: function () {
      console.log("aha");
    },
    onEditorBlur: function (a) {
      // console.log(a);
    },
    onEditorFocus: function (a) {
      console.log(a.root.innerHTML);
      // if (a.root.innerHTML == "<p>请在这里输入内容</p>") {
      //   console.log("1111111111");
      //   this.itemContent = " ";
      // }
    },
    onEditorReady: function (a) {
      // console.log(a);
    },

    aha: function () {
      console.log("测试");
    },
    choose: function (item) {
      console.log("改变目录", item);

      this.hidden(1);
      this.hidden(2);
      this.hidden(3);

      this.showitem = item;
      this.mainflag = true;
      this.showContent = -1;
      this.showTipMenu1 = false;
      this.showTipMenu2 = false;
      this.showFirstClassify = true;
      this.showSecondClassify = false;

      //动态改变样式
      this.whichContent = item;

      if (item == 2) {
        axios({
          methods: "get",
          url: "https://jwgf.henu.edu.cn:443/cobject/queryAllCObject",
        }).then((res) => {
          console.log(res.data);
          this.allObj = res.data;
        });
      }
      if (item == 3) {
        this.tempSubMenu = [];
        //点击事项管理时获取到的一级目录
        //老版本
        // axios({
        //   methods: "get",
        //   url: "https://jwgf.henu.edu.cn:443/class/queryAllClass",
        // }).then((res) => {
        //   console.log(res.data);
        //   this.allClass1 = res.data;
        // });
        //新版本
        axios({
          methods: "get",
          url:
            "https://jwgf.henu.edu.cn:443/class/queryClassByDepart/" +
            this.role,
        }).then((res) => {
          console.log("根据角色查到的一级目录", res.data);
          this.allClass1 = res.data;
        });
        //编辑页查询所有内容
        // axios({
        //   methods: "get",
        //   url:
        //     "https://jwgf.henu.edu.cn:443/business/queryAllBusiness/" + this.pageNum,
        // }).then((res) => {
        //   console.log('未根据角色查询到的所有数据',res.data);
        //   let resTotal = res.data[res.data.length - 1];
        //   console.log("总数据数", resTotal.sum);
        //   this.totalItem = resTotal.sum;
        //   res.data.pop();
        //   this.mainflag = true;
        //   this.objList = res.data;
        // });
        //结束
        //编辑页根据角色查询到的内容
        axios({
          methods: "get",
          url:
            "https://jwgf.henu.edu.cn:443/business/queryBusByDep/" +
            this.role +
            "/" +
            this.pageNum,
        }).then((res) => {
          console.log("根据角色查询到的所有数据", res.data);
          let resTotal = res.data[res.data.length - 1];
          console.log("总数据数", resTotal.sum);
          this.totalItem = resTotal.sum;
          res.data.pop();
          this.mainflag = true;
          console.log(44444444444444444444444444444);
          this.objList = res.data;
          console.log(res.data);
          //此时前端没显示出来的原因是因为display=none
        });
        //结束
      }
    },
    chooseContent: function (index) {
      console.log("一级标题被点击", index);
      this.showContent = index + 1;
      if (index == 1) {
        this.showSecondClassify = true;
        this.showFirstClassify = false;
        this.showTipMenu1 = false;
        this.showTipMenu2 = false;
      } else {
        this.showFirstClassify = true;
        this.showSecondClassify = false;
        this.showTipMenu1 = false;
        this.showTipMenu2 = false;
      }
      //调取接口
      if (index == 1) {
        this.goInterface("menu2");
      } else {
        this.goInterface("menu1");
      }
    },
    sunmenuclicked: function (index) {
      console.log("二级标题被点击", index);
      console.log(this.mainflag);
      if (!this.mainflag) {
        this.mainflag = !this.mainflag;
      }
    },
    //进入文章发布页
    changepage: function (item) {
      console.log("点击了编辑");
      console.log(item);
      this.getFile(item.BusinessID);
      //编辑页用来保存BusinessID 以刷新附件列表
      this.editBusinessID = item.BusinessID;
      //尝试 可能会错1=======================================================================
      //这是为了解决发布文章编辑页面时上传文件后下面不能刷新新增的变量
      this.upData.BusinessID = this.editBusinessID;
      //判断从哪里进
      this.fromAdd = false;
      this.showitem = 4;
      this.addOrUpdata = false;
      this.showUpload1 = true;
      //请求详情页要展示的内容
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" +
          item.BusinessID,
      }).then((res) => {
        console.log(res.data);
        // this.midTransfer = res.data[0].ClassId;
        ///////////////////////////////////////////////////////修改
        // this.itemClassify2 = res.data[0].BusinessID;
        this.itemClassify1 = res.data[0].ClassId;
        this.itemClassify2 = res.data[0].BusinessClass;
        this.itemOOP = res.data[0].BusinessObject;
        this.itemName = res.data[0].BusinessName;
        this.itemContent = res.data[0].BusinessContent;
        this.itemPhone = res.data[0].ContactPhone;
        this.itemDepart = res.data[0].BusinessDepartment;
        this.itemID = res.data[0].BusinessID;
      });
      //请求所有一级标题
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/class/queryClassByDepart/" + this.role,
      }).then((res) => {
        console.log(res.data);
        this.itemClassify1List = res.data;
      });
      //请求所有对象
      axios({
        methods: "get",
        url: "https://jwgf.henu.edu.cn:443/cobject/queryAllCObject",
      }).then((res) => {
        console.log(res.data);
        this.oopList = res.data;
      });
    },
    cancle: function () {
      console.log("cancle");
    },
    confirm: function () {
      console.log("confirm");
      // this.editBusinessID=
      // itemClassify1: "ClassName", //一级标题的id
      // itemClassify2: "SubClassName", //二级标题的id           //2
      // itemOOP: "ObjectName",                                 //3
      // itemName: "BusinessName",                              //1
      // itemContent: "BusinessContent",                        //4
      // itemPhone: "ContactPhone",
      // itemDepart: "DepartName",                              //5
      console.log(
        "一级标题id",
        this.itemClassify1,
        "二级标题id",
        this.itemClassify2,
        "面向对象",
        this.itemOOP,
        "标题",
        this.itemName,
        "内容",
        this.itemContent,
        "电话",
        this.itemPhone,
        "部门",
        // this.itemDepart
        this.role
      );
      if (this.itemClassify1 == -1) {
        alert("请选择一级标题");
        return;
      }
      // else if (this.itemOOP == -1) {
      //   alert("请选择面向对象");
      //   return;
      // }
      else if (!this.itemName) {
        alert("请输入标题");
        return;
      } else if (!this.itemContent) {
        alert("请输入内容");
        return;
      }
      if (!this.showUpload1) {
        ///////////////////////////这是新增
        console.log("新增");
        axios({
          method: "POST",
          url: "https://jwgf.henu.edu.cn:443/business/addBusiness",
          data: {
            itemClassify1: this.itemClassify1,
            itemClassify2: this.itemClassify2,
            // itemOOP: this.itemOOP,
            itemName: this.itemName,
            itemContent: this.itemContent,
            // itemDepart: this.itemDepart,
            // itemDepart: 10,
            itemDepart: this.role,
          },
        }).then((res) => {
          alert("事项添加成功");
          console.log(res.data);
          //获取新增之后返回的id
          this.upData.BusinessID = res.data;
          this.upData.AttachmentType = this.AttachmentType;
          console.log(this.upData);

          console.log(this.$refs.upload.uploadFiles);
          console.log(this.$refs.Theupload1.uploadFiles);
          this.submitUpload();
          // setTimeout(this.getFile(res.data), 1000);
          this.mainflag = true;
          this.choose(3);

          // setTimeout(this.choose(3), 3000);
        });
      } else {
        /////////////////////////////这是更新
        console.log("更新");
        axios({
          method: "POST",
          url: "https://jwgf.henu.edu.cn:443/business/updateBusiness",
          data: {
            itemClassify1: this.itemClassify1,
            itemClassify2: this.itemClassify2,
            itemOOP: this.itemOOP,
            itemName: this.itemName,
            itemContent: this.itemContent,
            itemDepart: this.itemDepart,
            itemID: this.itemID,
          },
        }).then((res) => {
          alert("事项更新成功");
          console.log(res.data);
          this.allClass1 = res.data;
          // this.choose(3);
          this.submitUpload();
        });
      }
    },
    returnPage: function () {
      console.log("返回上一级");
      this.mainflag = true;
    },
    showTip: function () {
      console.log("弹框");
    },
    editClicked: function (item, id, name, department, ObjectName) {
      switch (item) {
        case "menu1":
          //获取一级分类维护下部门下拉列表
          axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/seacher/queryAllDepart",
          }).then((res) => {
            console.log(res.data);
            this.itemDepart1List = res.data;
          });

          //获取一级分类维护下对象下拉列表
          axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/cobject/queryAllCObject",
          }).then((res) => {
            console.log(res.data);
            this.itemObjList = res.data;
          });
          console.log("编辑了一级目录", id, name, department);
          this.id2tip = id;
          this.className2tip = name;
          this.department2tip = department;
          this.itemDepart1 = department;
          this.itemObj1 = ObjectName;
          console.log(ObjectName);
          this.showTipMenu1 = true;
          break;
        case "menu2":
          console.log("编辑了二级目录");
          console.log(id, name);
          console.log(this.dropdownValue);
          if (this.dropdownValue == 0) {
            alert("请先选择一级分类");
          } else {
            this.subId2tip = id;
            this.subClassName2tip = name;
            this.showTipMenu2 = true;
          }
          break;
        case "obj":
          console.log("编辑了对象目录");
          this.objId2tip = id;
          this.objName2tip = name;
          this.showTipObj = true;
          break;
      }
    },
    cancleClicked: function (item) {
      switch (item) {
        case "menu1":
          console.log("关闭了一级目录");
          this.className2tip = "";
          this.department2tip = "";
          this.showTipMenu1 = false;
          break;
        case "menu2":
          console.log("关闭了二级目录");
          this.showTipMenu2 = false;
          break;
        case "obj":
          console.log("关闭了二级目录");
          this.showTipObj = false;
          break;
        case "edit":
          console.log("关闭了编辑页面");
          this.showitem = 3;
          this.mainflag = true;
          this.choose(3);
          break;
      }
    },
    goInterface: function (item) {
      switch (item) {
        //登陆验证
        case "login":
          this.axiosGet("user/login/wang/123456");
          break;
        //查询一级目录
        case "menu1":
          // 查询所有一级目录
          // axios({
          //   methods: "get",
          //   url: "https://jwgf.henu.edu.cn:443/class/queryAllClass",
          // }).then((res) => {
          //   console.log(res.data);
          //   this.firstClassify = res.data;
          // });
          //按照部门查询一级目录
          axios({
            methods: "get",
            url:
              "https://jwgf.henu.edu.cn:443/class/queryClassByDepart/" +
              this.role,
          }).then((res) => {
            console.log(res.data);
            this.firstClassify = res.data;
          });
          break;
        //查询二级目录
        case "menu2":
          // console.log("点击二级分类查到的所有一级目录");
          console.log("点击二级分类维护");
          this.dropdownValue == 0;
          this.showAddBtn = false;
          this.showAdd2 = false;
          console.log("二级分类维护中一级分类下拉菜单的值", this.dropdownValue);
          // if (this.dropdownValue == 0) {
          //   this.showAddBtn = false;
          // }
          axios({
            methods: "get",
            url:
              "https://jwgf.henu.edu.cn:443/class/queryClassByDepart/" +
              this.role,
          }).then((res) => {
            console.log(res.data);
            this.dropdown1 = res.data;
          });
          // 点击二级分类查到的所有内容
          this.dropdownValue = 0;
          axios({
            methods: "get",
            url:
              "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClasses/" +
              this.role,
          }).then((res) => {
            console.log(res.data);
            // this.dropdown1 = res.data;
            this.secondClassify = res.data;
          });
        //////这里重复了 检查？？？？？？？？？？
        // axios({
        //   methods: "get",
        //   url: "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClasses",
        // }).then((res) => {
        //   console.log(res.data);
        //   // this.dropdown1 = res.data;
        //   this.secondClassify = res.data;
        // });
        // break;
      }
    },
    axiosGet: function (urlend) {
      console.log(urlend);
      // axios({
      //   methods: "get",
      //   url: "https://10.12.37.200:44380/" + urlend,
      // }).then((res) => {
      //   console.log(res.data);
      // });
    },
    assertClicked: function (item) {
      console.log("1111111111111");
      switch (item) {
        case "menu1":
          console.log("一级标题点击确定", "部门是：", this.itemDepart1);
          if (this.addClassName) {
            console.log(this.addClassName, this.itemDepart1);
            //该请求里面第二个参数原本是this.itemDepart1(根据下拉菜单选出的)
            //现在将this.itemDepart1固定为this.role 即账号对应的部门
            axios({
              methods: "get",
              header: {
                "Content-Type":
                  "application/x-www-form-urlencoded;charset=UTF-8",
              },
              url:
                "https://jwgf.henu.edu.cn:443/class/addClass/" +
                this.addClassName +
                "/" +
                this.role +
                "/" +
                this.itemObj1,
            }).then((res) => {
              console.log(res.data);
              this.chooseContent(0);
              this.hidden(1);
            });
          } else {
            alert("请检查你的输入");
          }
          break;
        case "menu2":
          console.log("修改二级标题");
          if (this.dropdownValue && this.addSubClassName) {
            console.log(this.dropdownValue, this.addSubClassName);
            axios({
              methods: "get",
              header: {
                "Content-Type":
                  "application/x-www-form-urlencoded;charset=UTF-8",
              },
              url:
                "https://jwgf.henu.edu.cn:443/subclass/addSubClass/" +
                this.addSubClassName +
                "/" +
                this.dropdownValue +
                "/",
            }).then((res) => {
              console.log(res.data);
              // this.chooseContent(1);
              console.log("9999999999999999999");
              //更新表格
              this.upSubClassify();
              //更新表格成功
              this.hidden(2);
            });
          } else {
            alert("请检查你的输入");
          }
          break;
        case "obj":
          console.log("生成新对象");
          if (this.newObjName) {
            console.log(this.newObjName);
            axios({
              methods: "get",
              url:
                "https://jwgf.henu.edu.cn:443/cobject/add/" + this.newObjName,
            }).then((res) => {
              console.log(res.data);
              this.choose(2);
              this.hidden(3);
            });
          } else {
            alert("请检查你的输入");
          }
          break;
      }
    },
    deleteClicked: function (item, index) {
      console.log(index);
      // console.log(this.firstClassify[index]);
      if (confirm("请再次确认是否要删除")) {
        switch (item) {
          case "menu1":
            console.log("一级标题删除点击了");
            axios({
              methods: "get",
              url: "https://jwgf.henu.edu.cn:443/class/deleteClass/" + index,
            }).then((res) => {
              console.log(res.data);
              this.chooseContent(0);
            });
            break;
          case "menu2":
            console.log("二级标题删除点击了");
            axios({
              methods: "get",
              url:
                "https://jwgf.henu.edu.cn:443/subclass/deleteSubClass/" + index,
            }).then((res) => {
              console.log(res.data);
              this.upSubClassify();
              this.goInterface("menu2");
            });
            // this.chooseContent(1);
            break;
          case "obj":
            console.log("对象管理删除点击了");
            axios({
              methods: "get",
              url:
                "https://jwgf.henu.edu.cn:443/cobject/deleteCObject/" + index,
            }).then((res) => {
              console.log(res.data);
              this.choose(2);
            });
            break;
          case "edit":
            console.log("编辑页删除点击了");
            axios({
              methods: "get",
              url:
                "https://jwgf.henu.edu.cn:443/business/deleteBusiness/" + index,
            }).then((res) => {
              alert("事项已成功删除");
              console.log(res.data);
              this.choose(3);
            });
            break;
        }
      }
    },
    showAdd(item) {
      switch (item) {
        case 1:
          if (!this.showAdd1) {
            this.showAdd1 = true;
            //获取一级分类维护下部门下拉列表
            axios({
              methods: "get",
              url: "https://jwgf.henu.edu.cn:443/seacher/queryAllDepart",
            }).then((res) => {
              console.log(res.data);
              this.itemDepart1List = res.data;
            });
            //获取一级分类维护下对象下拉列表
            axios({
              methods: "get",
              url: "https://jwgf.henu.edu.cn:443/cobject/queryAllCObject",
            }).then((res) => {
              console.log(res.data);
              this.itemObjList = res.data;
            });
          }
          break;
        case 2:
          if (!this.showAdd2) {
            this.addSubClassName = "";
            this.showAdd2 = true;
          }
          break;
        case 3:
          if (!this.showAdd3) {
            this.showAdd3 = true;
          }
          break;
        case 4:
          this.showitem = 4;
          this.itemName = "";
          // this.itemContent = "请在这里输入内容";
          this.itemContent = "";
          this.itemPhone = "";
          this.itemDepart = "";
          this.detailFileMSG = [];
          this.editBusinessID = -1;
          this.showUpload1 = false;
          //解决分类初始化问题 如果是从增加进入的时候为true
          this.fromAdd = true;
          axios({
            methods: "get",
            url:
              "https://jwgf.henu.edu.cn:443/class/queryClassByDepart/" +
              this.role,
          }).then((res) => {
            console.log(res.data);
            this.itemClassify1List = res.data;
          });
          this.itemClassify2List = [];
          //请求所有对象
          axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/cobject/queryAllCObject",
          }).then((res) => {
            console.log(res.data);
            this.oopList = res.data;
          });
          break;
      }
    },
    hidden(item) {
      switch (item) {
        case 1:
          if (this.showAdd1) {
            this.showAdd1 = false;
          }
          break;
        case 2:
          if (this.showAdd2) {
            this.showAdd2 = false;
          }
          break;
        case 3:
          if (this.showAdd3) {
            this.showAdd3 = false;
          }
          break;
      }
    },
    tipOK(item) {
      switch (item) {
        case "menu1":
          console.log("tip1确定");
          axios({
            methods: "get",
            url:
              "https://jwgf.henu.edu.cn:443/class/updateClass/" +
              this.id2tip +
              "/" +
              this.className2tip +
              "/" +
              this.itemDepart1 +
              "/" +
              this.itemObj1,
          }).then((res) => {
            this.showTipMenu1 = false;
            console.log(res.data);
            this.chooseContent(0);
          });
          break;
        case "menu2":
          console.log("tip2确定");
          axios({
            methods: "get",
            url:
              "https://jwgf.henu.edu.cn:443/subclass/updateSubClass/" +
              this.subId2tip +
              "/" +
              this.subClassName2tip +
              "/" +
              this.dropdownValue,
          }).then((res) => {
            console.log(res.data);
            //更新列表
            this.upSubClassify();
            //关闭弹窗
            this.showTipMenu2 = false;
          });
          break;
        case "obj":
          console.log("tip3确定");
          axios({
            methods: "get",
            url:
              "https://jwgf.henu.edu.cn:443/cobject/updateCObject/" +
              this.objId2tip +
              "/" +
              this.objName2tip,
          }).then((res) => {
            console.log("1111111111111111111111111", res.data);
            this.cancleClicked("obj");
            this.choose(2);
          });
          break;
      }
    },
    showSubMenu(subid) {
      this.dynamicClass = -1;
      axios({
        methods: "get",
        url: "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClass/" + subid,
      }).then((res) => {
        this.tempSubMenu = res.data;
        console.log(this.tempSubMenu);
      });
    },
    subMenuClicked(subMenuId, index) {
      // 动态增加类
      this.dynamicClass = index;
      console.log(subMenuId);
      this.itemDepart = subMenuId;
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/business/queryBusBySubId/" +
          subMenuId +
          "/" +
          this.pageNum,
      }).then((res) => {
        console.log(res.data);
        let resTotal = res.data[res.data.length - 1];
        console.log("总数据数", resTotal.sum);
        this.totalItem = resTotal.sum;
        res.data.pop();
        console.log(res.data);
        console.log(5555555555555555555);
        this.objList = res.data;
      });
    },
    //上传组件相关
    // handleRemove(file) {
    //   console.log(file);
    // },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    filDepartment(department) {
      console.log(department);
    },
    upSubClassify() {
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClass/" +
          this.recordStep1,
      }).then((res) => {
        console.log(res.data);
        this.secondClassify = res.data;
        console.log("更新表格成功");
      });
    },
    ahaha123(event) {
      console.log(event.target.value);
    },
    //文件上传相关
    submitUpload() {
      // this.$refs.upload.submit();
      // 判断两个成功的同时上传成功的变量
      let upStatus1 = false;
      let upStatus2 = false;

      // 下面的代码将创建一个空的FormData对象:
      const formData = new FormData();
      //制度文件的数据
      this.fileList = this.$refs.upload.uploadFiles;
      // 你可以使用FormData.append来添加键/值对到表单里面；
      this.fileList.forEach((file) => {
        formData.append("file", file.raw);
      });
      // 添加自定义参数，不传可删除
      // formData.append("parentId", "49");
      // upData: {
      //   BusinessID: 1,
      //   AttachmentType: 1,
      // },
      formData.append("BusinessID", this.upData.BusinessID);
      formData.append("AttachmentType", 0);
      console.log(formData.get("BusinessID"));
      console.log(formData.get("file"));

      //自定义的接口也可以用ajax或者自己封装的接口
      axios({
        method: "POST",
        url: "https://jwgf.henu.edu.cn:443/attachment/upload", //填写自己的接口
        data: formData, //填写包装好的formData对象
      }).then((res) => {
        console.log(res.data);
        if (res.data == "上传成功") {
          // this.$message.success("上传成功");
          upStatus1 = true;

          // if (upStatus1 && upStatus2) {
          //   this.$message.success("上传成功");
          //   upStatus1 = false;
          //   upStatus2 = false;
          //   this.getFile(this.itemID);
          //   //跳转页面
          // }

          //上传附件成功后再上传表格

          // 上传表格
          const formData1 = new FormData();
          this.fileList1 = this.$refs.Theupload1.uploadFiles;
          this.fileList1.forEach((file1) => {
            formData1.append("file", file1.raw);
          });
          formData1.append("BusinessID", this.upData.BusinessID);
          formData1.append("AttachmentType", 1);
          console.log(formData1.get("BusinessID"));
          console.log(formData1.get("file"));

          axios({
            method: "POST",
            url: "https://jwgf.henu.edu.cn:443/attachment/upload",
            data: formData1,
          }).then((res) => {
            console.log(res.data);
            if (res.data == "上传成功") {
              // this.$message.success("上传成功");
              upStatus2 = true;
              if (upStatus1 && upStatus2) {
                this.$message.success("上传成功");
                upStatus1 = false;
                upStatus2 = false;
                this.getFile(this.itemID);
                //跳转页面
              }
            } else {
              // this.$message.error("上传失败");
              upStatus2 = false;
            }
            //清空fileList
            this.fileList1 = [];
          });

          //上传附件成功后再上传表格结束
        } else {
          // this.$message.error("上传失败");
          upStatus1 = false;
        }
        //清空fileList
        this.fileList = [];
      });
    },
    afterSubmitUpload() {},
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    upsuccess() {
      console.log("上传成功");
      this.fileList = [];

      this.getFile(this.upData.BusinessID);
      console.log(this.upData.BusinessID);
    },
    filehttpsRequest(val) {
      console.log("上传文件");
      console.log(val.file);
      // axios({
      //   method: "post",
      //   headers: {
      //     "Content-Type": multipart / form - data,
      //   },
      //   url: "https://jwgf.henu.edu.cn:443/attachment/upload",
      //   params: {
      //     data: val.file,
      //   },
      // }).then((res) => {
      //   console.log(res.data);
      // });
    },
    //返回要发送到的URL
    fileAction1(fromADD, id) {
      // this.filedata =
      //   "https://jwgf.henu.edu.cn:443/attachment/upload/" +
      //   this.itemID +
      //   "/" +
      //   this.AttachmentType;
      // console.log(fromADD, "look");
      console.log(this.fileList);
    },
    //分页相关
    currentPage(index) {
      console.log(index);
      this.pageNum = index;
      this.choose(3);
    },

    //获取文件
    getFile: function (articleID) {
      console.log("获取文件");
      console.log(articleID);
      //第一个this.showUpload1是用来判断文章发布页是从新增来还是编辑来
      if (this.showUpload1) {
        if (this.mainflag) {
          this.mainflag = !this.mainflag;
        }
      }
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" +
          articleID,
      }).then((res) => {
        console.log("获取到的文件", res.data);
        if (res.data) {
          res.data.shift();
        }
        this.detailFileMSG = res.data;
        // this.dealMSG(res.data);
      });
    },
    //删除文件
    deleteFile(fileid) {
      if (confirm("请确定是否删除此附件")) {
        console.log("点击了删除文件按钮");
        console.log(fileid);
        axios({
          methods: "get",
          url: "https://jwgf.henu.edu.cn:443/attachment/deleteAtt/" + fileid,
        }).then((res) => {
          console.log(res.data);
          this.getFile(this.itemID);
        });
      }
    },
    //
    beforeRemove() {
      console.log("222222222222222222");
      this.getFile(this.upData.BusinessID);
    },
  },
};
</script>

<style scoped>
.quillbox {
  width: 1000px;
  /* height: 1800px; */
  margin: auto;
  margin-top: 20px;
  height: 800px;
}
.pc_manage {
  width: 1200px;
  margin: auto;
  background-color: whitesmoke;
  text-align: center;
}
.manageTop {
  width: 1200px;
  height: 40px;
  background-color: #0099cc;
}
.title {
  height: 200px;
  font-size: 50px;
  color: #fff;
  color: #000;
  line-height: 200px;
}
.navbar {
  width: 100%;
  height: 65px;
  background-color: #0099cc;
}
.navbaritem {
  float: left;
  width: 400px;
  height: 65px;
  line-height: 65px;
  color: white;
  font-size: 23px;
  box-sizing: border-box;
  /* background-color: pink; */
}
.navbaritem1 {
  float: left;
  width: 400px;
  height: 65px;
  line-height: 65px;
  color: #000;
  font-size: 23px;
  box-sizing: border-box;
  /* background-color: pink; */
}
.navbaritem:hover {
  cursor: pointer;
  color: #000;
}
.navbaritem2 {
  border-left: 2px solid #000;
  border-right: 2px solid #000;
}
.navbaritem4 {
  border-left: 2px solid #000;
}
.header {
  height: 70px;
  line-height: 70px;
  font-size: 30px;
  text-align: left;
  box-sizing: border-box;
  padding-left: 20px;
}
.showbar {
  overflow: hidden;
  margin-top: 20px;
}
.showclassify {
  width: 1100px;
  margin: auto;
  margin-top: 20px;
  background-color: #fff;
  padding-bottom: 50px;
}

.sidebar {
  width: 200px;
  min-height: 500px;
  /* background-color: bisque; */
  background-color: whitesmoke;
  float: left;
}
.menuitem {
  width: 100%;
  line-height: 50px;
  background-color: #0099cc;
  font-size: 20px;
  color: aliceblue;
  border-bottom: 1px solid #fff;
}
.menuitem:hover {
  color: #000;
  cursor: pointer;
}
.menuitem:hover .submenuitem {
  /* .submenuitem { */
  display: block;
  width: 100%;
  background-color: white;
  color: #000;
  border-bottom: 1px solid #000;
  box-sizing: border-box;
}
.submenuitem {
  background-color: white;
  color: #000;
  border-bottom: 1px solid #000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.submenuitem:hover {
  color: #0099cc;
  cursor: pointer;
}

.menuitem1 {
  width: 100%;
  line-height: 50px;
  background-color: #0099cc;
  font-size: 20px;
  color: aliceblue;
  border-bottom: 1px solid #fff;
  cursor: pointer;
}
.dynamicClass1 {
  color: #0099cc;
}

.main {
  width: 1000px;
  float: left;
  background-color: whitesmoke;
  /* margin: 20px; */
  box-sizing: border-box;
}
.main1 {
  width: 960px;
  min-height: 500px;
  background-color: #fff;
  margin: auto;
  border-radius: 8px;
  /* border: 2px solid black; */
  box-sizing: border-box;
  /* padding-top: 20px; */
  padding-bottom: 50px;
}
.topsearch {
  width: 920px;
  height: 50px;
  margin: auto;
  /* background-color: antiquewhite; */
}
.toptitle {
  width: 920px;
  height: 50px;
  margin: auto;
  background-color: whitesmoke;
}
.listCP {
  width: 25%;
  height: 50px;
  line-height: 50px;
  font-size: 23px;
  float: left;
  box-sizing: border-box;
  border-right: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  border-right: 0;
}
.ctnCP {
  width: 50%;
  height: 50px;
  box-sizing: border-box;
  float: left;
  color: #1890ff;
}
.ctnCP:hover {
  font-size: 16px;
}
.editCTN {
  border-right: 2px solid #000;
}
.contentCP {
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 0;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.maintop {
  width: 100%;
  /* height: 900px; */
  border-radius: 8px;
  /* border: 2px solid black; */
  box-sizing: border-box;
  padding-bottom: 20px;
}
.maintopTitle {
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 25px;
}
.maintopContent {
  width: 900px;
  height: 900px;
  margin: auto;
  border: 2px solid black;
  padding: 20px;
  box-sizing: border-box;
}
.maintopAppend {
  width: 900px;
  height: 200px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.maintopAppendBox {
  width: 50%;
  height: 200px;
  float: left;
  background-color: whitesmoke;
  box-sizing: border-box;
}
.boxLBorder {
  border-left: 2px solid #fff;
}
.AppendBoxTitle {
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: left;
  font-size: 23px;
  box-sizing: border-box;
  padding-left: 15px;
  /* background-color: #0099cc; */
}
.AppendBoxTxt {
  width: 90%;
  margin: auto;
  height: 40px;
  line-height: 40px;
  background-color: #cccccc;
}
.AppendBoxTxt:hover {
  cursor: pointer;
  font-size: 20px;
}
.maintopFooter {
  width: 900px;
  height: 50px;
  margin: auto;
  background-color: cadetblue;
}
.maintopFooterBox {
  width: 50%;
  height: 50px;
  line-height: 50px;
  font-size: 23px;
  float: left;
  background-color: whitesmoke;
  text-align: left;
  box-sizing: border-box;
}
.mainreturn {
  margin-top: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 22px;
  color: white;
  background-color: #0099cc;
}
.mainreturn:hover {
  cursor: pointer;
  font-size: 25px;
}
.maintopA {
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  margin-bottom: 20px;
  color: #fff;
  background-color: #0099cc;
  border-radius: 0;
}
.mainhead {
  width: 920px;
  height: 40px;
  margin: auto;
  margin-bottom: 5px;
  box-sizing: border-box;
  line-height: 40px;
  font-size: 23px;
  text-align: left;
  background-color: #fff;
  /* background-color: bisque; */
}
.mainheadL {
  width: 300px;
  float: left;
}
.mainheadR {
  width: 300px;
  height: 40px;
  background-color: whitesmoke;
  float: left;
}
.maintitle {
  width: 920px;
  height: 40px;
  margin: auto;
  margin-bottom: 15px;
  margin-top: 15px;
  background-color: aquamarine;
}
.maintitle1 {
  width: 75%;
  height: 40px;
  line-height: 40px;
  font-size: 23px;
  float: left;
  background-color: #cccccc;
}
.maintitle2 {
  width: 25%;
  box-sizing: border-box;
  border-left: 2px solid #fff;
}
.contentList {
  width: 920px;
  height: 50px;
  /* line-height: 40px; */
  /* background-color: whitesmoke; */
  box-sizing: border-box;
  margin-left: 20px;
  margin-right: 20px;
}
.contentList:hover {
  cursor: pointer;
}
.contentListL {
  width: 75%;
  height: 100%;
  background-color: whitesmoke;
  float: left;
}
.contentListL:hover {
  color: #0099cc;
  cursor: pointer;
}
.contentListAdd {
  width: 690px;
  height: 40px;
  outline: none;
  font-size: 20px;
  box-sizing: border-box;
  padding-left: 10px;
}
.contentListR {
  width: 25%;
  height: 100%;
  background-color: whitesmoke;
  float: left;
  box-sizing: border-box;
  border-left: 2px solid #fff;
}
.listRDelete {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin: auto;
  background-color: #0099cc;
}
.listRDelete:hover {
  cursor: pointer;
  background-color: brown;
}
.contentListPlus {
  width: 920px;
  height: 40px;
  line-height: 40px;
  font-size: 50px;
  margin: auto;
  margin-top: 15px;
  background-color: whitesmoke;
}
.contentListPlus:hover {
  cursor: pointer;
  font-size: 55px;
}
.showbararticle2 {
  width: 1100px;
  padding-bottom: 30px;
  margin: auto;
  margin-top: 20px;
  padding-top: 20px;
  background-color: white;
}
.quillTitle {
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 35px;
  /* background-color: #0099cc; */
}
.QheadClassify {
  width: 1000px;
  height: 50px;
  margin: auto;
  margin-left: 175px;
  /* background-color: whitesmoke; */
}
.QheadName {
  width: 1000px;
  height: 50px;
  margin: auto;
  margin-top: 10px;
  margin-left: 175px;
  /* background-color: whitesmoke; */
}
.footer {
  width: 1000px;
  height: 60px;
  margin: auto;
  margin-top: 10px;
  /* background-color: aquamarine; */
}
.footerL {
  width: 50%;
  height: 100%;
  line-height: 60px;
  /* background-color: red; */
  float: left;
  font-size: 30px;
  color: red;
  background-color: bisque;
}
.footerL:hover {
  cursor: pointer;
}

.footerR {
  width: 50%;
  height: 100%;
  line-height: 60px;
  /* background-color: green; */
  float: right;
  font-size: 30px;
  color: green;
  background-color: aliceblue;
}
.footerR:hover {
  cursor: pointer;
}
.bottom {
  /* padding-top: 200px; */
  /* padding-bottom: 50px; */
  margin-top: 20px;
  font-size: 15px;
  height: 65px;
  line-height: 65px;
  color: #fff;
  background-color: #0099cc;
}

.topObj {
  width: 1100px;
  height: 60px;
  margin: auto;
}
.table {
  position: relative;
  width: 1100px;
  margin: auto;
}
.tableTitle {
  width: 100%;
  height: 50px;
  margin: auto;
  background-color: whitesmoke;
}
.tableListCP {
  width: 366px;
  height: 50px;
  font-size: 14px;
  line-height: 50px;
  box-sizing: border-box;
  float: left;
  /* border-right: 2px solid #000; */
  /* border: 1px solid #ccc; */
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.tableRow {
  width: 100%;
  height: 50px;
  margin: auto;
  background-color: white;
}
.operate {
  width: 200px;
  height: 40px;
  margin: auto;
  margin-top: 5px;
}
.operateCP {
  width: 50%;
  height: 40px;
  line-height: 40px;
  float: left;
  box-sizing: border-box;
  color: #1890ff;
}
.operateCP:hover {
  cursor: pointer;
  font-size: 15px;
}
.popup {
  width: 1100px;
  margin: auto;
  padding-top: 20px;
  padding-bottom: 30px;
}
.PopupBox {
  width: 500px;
  margin: auto;
  padding: 15px;
  background-color: whitesmoke;
  border-radius: 5px;
  box-shadow: 0 0 10px 5px #888888;
}
.PopupBoxTop {
  /* border: 2px solid #000; */
  padding: 20px;
  border-radius: 10px;
  background-color: white;
}
.popupBoxTxt {
  width: 400px;
  height: 50px;
  line-height: 50px;
  font-size: 25px;
  margin: auto;
}
.popupBoxTxtCP {
  width: 50%;
  height: 50px;
  float: left;
}
.popupBoxTxtCPL {
  width: 30%;
}
.popupBoxTxtCPR {
  width: 70%;
}
.popupBoxInput {
  width: 272px;
  height: 30px;
}
.PopupBoxCfrm {
  width: 100%;
  height: 50px;
  /* margin-top: 10px; */
  background-color: white;
}
.popupoption {
  width: 80px;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  border-radius: 4px;
  margin-top: 10px;
  margin-left: 115px;
  color: white;
  background-color: #28a3ff;
  float: left;
  border-radius: 40px;
}
.popupoption:hover {
  cursor: pointer;
  font-size: 16px;
}
.tableClssify0 {
  width: 900px;
}
.tableClssify {
  width: 900px;
}
.tableClssify1 {
  width: 225px;
}
.tableClssify11 {
  width: 300px;
}
.tableClssify2 {
  width: 225px;
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tableClssify22 {
  width: 300px;
}
.tableClssify3 {
  width: 900px;
}
.tableClssify4 {
  font-size: 18px;
}
.tableClssifyTo5 {
  width: 180px;
}
.classTitle {
  width: 200px;
  height: 60px;
  line-height: 60px;
  font-size: 23px;
  /* background-color: aquamarine; */
  float: left;
}
.classSearch {
  width: 300px;
  height: 60px;
  line-height: 60px;
  /* background-color: bisque; */
  float: left;
}
.articleTop {
  width: 166px;
  height: 50px;
  line-height: 50px;
  float: left;
}
.articleMid {
  width: 166px;
  height: 50px;
  line-height: 50px;
  float: left;
}
.hidden {
  width: 80px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  font-size: 15px;
  color: white;
  background-color: #28a3ff;
  border-radius: 4px;
  float: right;
}
.hidden:hover {
  cursor: pointer;
  font-size: 16px;
}
.dingweiF {
  position: relative;
}
.dingweiS {
  position: absolute;
  top: 0;
}
.inputStyle1 {
  width: 150px;
  height: 24px;
  outline: none;
  margin-left: 8px;
}
.inputstyle2 {
  width: 200px;
  height: 30px;
  margin-left: -180px;
  outline: none;
}
.inputStyle3 {
  width: 474px;
  height: 24px;
  outline: none;
  margin-left: 8px;
}
.dropdownStyle1 {
  width: 150px;
  height: 30px;
  outline: none;
}
.dropdownStyle2 {
  width: 150px;
  height: 30px;
  outline: none;
}
.dropdownStyle3 {
  width: 280px;
  height: 30px;
}
.obgManage {
  width: 1150px;
  margin: auto;
  margin-top: 20px;
  min-height: 600px;
  background-color: white;
  /* border: 2px solid black; */
  border-radius: 8px;
}
.zhanwi12 {
  width: 100%;
  height: 80px;
}
.phoneAndDepart {
  width: 1000px;
  margin: auto;
  height: 60px;
  background-color: whitesmoke;
}
.uploadBOX {
  width: 1000px;
  margin: auto;
  margin-top: 20px;
  min-height: 250px;
  overflow: hidden;
  background-color: whitesmoke;
}
.uploadBoxCP {
  width: 50%;
  /* height: 100%; */
  float: right;
  padding-bottom: 10px;
  /* background-color: #0099cc; */
}
.phoneAndDepartCP {
  width: 50%;
  height: 100%;
  float: left;
  /* background-color: aquamarine; */
}
.phoneAndDepartCPL {
  width: 200px;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  float: left;
  /* background-color: #0099cc; */
}
.phoneAndDepartCPR {
  width: 300px;
}
.uploadBoxR {
  margin-top: 20px;
  height: 230px;
  /* background-color: #888888; */
}
.positionF {
  position: relative;
}
.positionS {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -111px;
}
.uploadTitle {
  width: 100%;
  height: 70px;
  line-height: 70px;
  margin-top: 10px;
  font-size: 30px;
  /* background-color: #0099cc; */
}
.chooseTypeBox {
  width: 400px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  background-color: white;
}
.chooseTypeBoxL {
  width: 200px;
  height: 40px;
  line-height: 40px;
  float: left;
  /* background-color: #888888; */
  font-size: 16px;
}
.chooseTypeBoxR {
  width: 200px;
  height: 40px;
  float: left;
  /* background-color: violet; */
}
.chooseTypeSelect {
  width: 150px;
  margin-top: 5px;
  height: 30px;
  outline: none;
}
.historyFileBox {
  width: 660px;
  margin: auto;
  margin-top: 10px;
  background-color: white;
  overflow: hidden;
}
.historyFileBg {
  background-color: #f1fafa;
}
.historyFileType {
  float: left;
  width: 80px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.historyFileCTN {
  float: left;
  width: 500px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.historyFileDelete {
  float: left;
  width: 80px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.historyFileDelete1 {
  color: red;
}
.historyFileDelete1:hover {
  cursor: pointer;
  font-size: 16px;
}
.theUpload {
  width: 400px;
  margin: auto;
  min-height: 175px;
  background-color: white;
}
.showAttach {
  width: 1000px;
  margin: auto;
  margin-top: 10px;
  min-height: 200px;
  background-color: whitesmoke;
  padding-top: 10px;
  padding-bottom: 10px;
}
.textLeft {
  text-align: left;
}
</style>